export { default } from './SearchEmpty';
